export default __webpack_public_path__ + "static/media/BO.316cc5e8.svg";